import * as Yup from "yup";
import { transformSnakeToCamel, transformModelToJson } from "utils/transform";
import { PaginationSchema } from "model/_common";
import { ProductSchema, BrandSchema, CategorySchema } from "model/_base";

// Yup Schemas
export const DataSchema = ProductSchema.clone().transform(transformSnakeToCamel).concat(Yup.object().transform(transformSnakeToCamel)).shape({
  brandId: Yup.string().nullable(),
  brand: BrandSchema.nullable(),
  categoryId: Yup.string().nullable(),
  category: CategorySchema.nullable(),
});

export const ProductRecomSchema = Yup.object().shape({
  data: Yup.array().of(DataSchema),
  pagination: PaginationSchema,
});

export class ProdRecomModel {
  /**
   * Transform json to model
   * @param {object} json - JSON data to transform
   * @returns {object} Transformed model
   */
  static jsonToModel(json) {
    try {
      const model = ProductRecomSchema.cast(json, {
        abortEarly: false,
        stripUnknown: true,
      });
      return model;
    } catch (error) {
      throw error;
    }
  }

  /**
   * Transform model to json
   * @param {object} model - Model to transform
   * @returns {object} Transformed JSON
   */
  static modelToJson(model) {
    return transformModelToJson(model);
  }
}
